import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CoinInfo } from '../models/coin-info';
import { CoinRating } from '../models/coin-info';

@Injectable({
  providedIn: 'root'
})
export class CoinInfoService {

  private COIN_INFO_QUERY = `
    query CoinInfo($currency: String, $quoteCurrency: String) {
      coinInfo(currency: $currency) {
        text
        links {
          key
          link
        }
        metadata (quoteCurrency: $quoteCurrency) { 
          maxSupply { 
              amount
              currency
          }
          circulatingSupply { 
              amount
              currency
          }
          circulatingSupplyPercentage
          tags { 
              name
              slug
              category
          }
          rank
          quote { 
              currency { 
                  code
                  name
              }
              marketCap { 
                  amount
                  currency
              }
              tradeVolume24hour { 
                  amount
                  currency
              }
              fullyDilutedValue {
                amount
                currency
              }
          }
          smartContractAudit {
            auditor
            link
            date
          }
          issuanceDate
      }
      }
    }
  `;

  private COIN_RATING_QUERY = `
    query CoinRating($currency: String) {
      coinRating(currency: $currency) {
        level
        score
        underlyingTechnologySecurity
        ecosystemDevelopment
        roadmapProgress
        tokenEconomics
        teamPartnersInvestors
        tokenPerformance
      }
    }
  `;

  constructor(
    private api: ApiService
  ) {

  }

  getCoinInfo(currency: string = null, quoteCurrency: string = 'USD'): Observable<CoinInfo[]> {
    return this.api.get(this.COIN_INFO_QUERY,{currency, quoteCurrency}, false).pipe(
      switchMap((response) => {
        if (response["errors"]) {
          return throwError(response);
        }

        return of(response['data']?.['coinInfo'] ?? []);
      }),
      this.api.unifyErrors()
    );
  }

  getCoinRating(currency: string = null): Observable<CoinRating[]> {
    return this.api.get(this.COIN_RATING_QUERY,{currency}, false).pipe(
      switchMap((response) => {
        if (response["errors"]) {
          return throwError(response);
        }

        return of(response['data']?.['coinRating'] ?? []);
      }),
      this.api.unifyErrors()
    );
  }
}
